import { all } from 'redux-saga/effects';
import uploadSaga from './upload';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function* rootSaga() {
  yield all([uploadSaga()]);
}
